import React, { memo } from 'react'
import './styles/sanitize.css'
import './styles/base.css'
import Sandbox from './screens/Sandbox'
import VersionProvider from './screens/VersionProvider'
import AuthProvider from './screens/AuthProvider'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import RocketScreen from './screens/RocketScreen'
import PromosScreen from './screens/PromosScreen'

function App() {
  return (
    <AuthProvider>
      <MemoContent />
    </AuthProvider>
  )
}

const appRouter = createBrowserRouter([
  {
    path: '/',
    element: (
      <VersionProvider>
        <Sandbox />
      </VersionProvider>
    ),
    index: true,
  },
  {
    path: '/rockets/:id',
    element: (
      <VersionProvider>
        <RocketScreen />
      </VersionProvider>
    ),
  },
  { path: '/promo', element: <PromosScreen /> },
])

const MemoContent = memo(() => {
  return <RouterProvider router={appRouter} />
})

export default App
